// @ts-nocheck
import cardValidator from 'card-validator';
import { CardDetails, CardValidatorResult, CreditCardFormMessages, CreditCardValues, ValidateProps } from './@types';

export default function validate(values: CreditCardValues = {}, props: ValidateProps): Record<string, string> {
    const errors: Record<string, string> = {};

    validateCardholderName(values, errors, props.messages);
    validateExpiryDate(values, errors, props.messages);

    if (!(props.isCardWallet && props.initialValues)) { // initialValues and isCardWallet means we're in edit mode
        validateCardNumber(values, errors, props.messages);
        validateCvv(values, props.cardTypeInfo, errors, props.messages);
    }

    return errors;
}

function validateCardholderName(values: CreditCardValues, errors: Record<string, string>, messages: CreditCardFormMessages): void {
    if (!values.cardHolderName?.trim()) {
        errors.cardHolderName = messages.errors.required({
            field: messages.creditCardForm.cardHolderName(),
        });
    } else if (values.cardHolderName.length > 100) {
        errors.cardHolderName = messages.errors.maxLength({ characters: 100 });
    }
}

function validateCardNumber(values: CreditCardValues, errors: Record<string, string>, messages: CreditCardFormMessages): void {
    if (!values.number?.trim()) {
        errors.number = messages.errors.required({
            field: messages.creditCardForm.number(),
        });
    } else if (!cardValidator.number(values.number).isValid) {
        errors.number = messages.errors.invalid({
            field: messages.creditCardForm.number(),
        });
    }
}

function validateExpiryDate(values: CreditCardValues, errors: Record<string, string>, messages: CreditCardFormMessages): void {
    const expiryKey = 'expiryDateStr';

    if (!values[expiryKey]) {
        errors[expiryKey] = messages.errors.required({
            field: messages.creditCardForm.expiryDate(),
        });
    } else {
        let month = '';
        let year = '';

        if (typeof values[expiryKey] === 'string' && values[expiryKey].includes('/')) {
            const [mm, yy] = values[expiryKey].split('/');
            month = mm;
            year = yy;
        } else if (typeof values[expiryKey] === 'object' && values[expiryKey] !== null) {
            month = values[expiryKey].month;
            year = values[expiryKey].year;
        }

        if (!cardValidator.expirationDate({ month, year }).isValid) {
            errors[expiryKey] = messages.errors.invalid({
                field: messages.creditCardForm.expiryDate(),
            });
        }
    }
}

function validateCvv(
    values: CreditCardValues,
    cardTypeInfo: ValidateProps['cardTypeInfo'] | undefined,
    errors: Record<string, string>,
    messages: CreditCardFormMessages,
): void {
    const cardNumberResult: CardValidatorResult = cardValidator.number(values.number);
    const cardDetails = createCardDetails(cardNumberResult.card, cardTypeInfo);

    if (!values.cvv || !values.cvv.trim()) {
        errors.cvv = messages.errors.required({
            field: messages.creditCardForm.cvv(cardDetails),
        });
    } else if (!cardValidator.cvv(values.cvv, cardDetails.cvvSize).isValid) {
        errors.cvv = messages.errors.invalid({
            field: messages.creditCardForm.cvv(cardDetails),
        });
    }
}

function createCardDetails(card: CardValidatorResult['card'], cardTypeInfo: ValidateProps['cardTypeInfo'] | undefined): CardDetails {
    return {
        cvvType: card?.code.name || cardTypeInfo?.cvvType || 'CVV',
        cvvSize: card?.code.size || cardTypeInfo?.cvvSize || [3, 4],
    };
}
